import { IBooking } from 'shared-types/SharedTypes';
import { ITableObj } from './types';

const NS = 'TableUtilsService';

class TableUtilsService {


  public removePastBookingsFromTable(booking: IBooking, tableObj: ITableObj) {
    // check to see if any of the past booking have ended
    tableObj.bookingsAtTable.forEach((pastBooking: IBooking, p: number) => {
      if (pastBooking && booking.bookingMin >= (pastBooking.bookingMin + (pastBooking.duration as number))) {
        tableObj.totalPeopleAtTable -= pastBooking.people;
        tableObj.bookingsAtTable[p] = null;
      }
    })
  }

  public addBookingRelatedDataToTables(booking: IBooking) {
    const tables = {} as {[key: string]: ITableObj};
    booking.tables.forEach((table) => {
      if (table && table.shared) {
        // create the table look up
        if (!tables[table._id]) {
          tables[table._id] = {
            lastBooking: null,
            totalPeopleAtTable: 0,
            bookingsAtTime: [],
            table: table,
            bookingsAtTable: []
          };
        }
        const tableObj = tables[table._id];
        tableObj.table = table;

        // check if the next booking overlaps with the last
        if (tableObj.lastBooking && (booking.bookingMin < (tableObj.lastBooking.bookingMin + (+tableObj.lastBooking.duration)))) {
          // the booking starts before the last booking finishes
          tableObj.totalPeopleAtTable += booking.people;
          // check to see if any of the past booking have ended
          this.removePastBookingsFromTable(booking, tableObj);
          tableObj.bookingsAtTable.push(booking);
        } else {

          tableObj.totalPeopleAtTable = booking.people;
          tableObj.bookingsAtTime = [];
          tableObj.bookingsAtTable = [booking];
        }
        tableObj.lastBooking = booking;
        tableObj.bookingsAtTime.push(booking);
      }
    });

    this.addSharedOverCapacityToBooking(tables);
  }

  private addSharedOverCapacityToBooking(tables: {[key: string]: ITableObj}): void {
    for (const key in tables) {
      const {bookingsAtTime, totalPeopleAtTable, table} = tables[key];
      const sharedOverCapacity = totalPeopleAtTable > table.capacity;
      bookingsAtTime.forEach((b) => {
        b.sharedOverCapacity = sharedOverCapacity;
      });
    }
  }
}

const instance = new TableUtilsService();
export default instance as TableUtilsService;
